import {NgModule} from '@angular/core';
import {TooltipModule} from '../tooltip/tooltip.module';
import {RateOfReturnTooltipComponent} from './rate-of-return-tooltip.component';

@NgModule({
    imports: [TooltipModule],
    exports: [RateOfReturnTooltipComponent],
    declarations: [RateOfReturnTooltipComponent]
})
export class RateOfReturnTooltipModule {
}